import React, { useState, useEffect } from 'react';
import {
  Row, Input, Button, Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { putAPI_Update_Response } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ImageGallery from '../../gallery/index'

function BotResponseButton({
  reloadBotResponse,
  caption,
  url,
  code,
  messages,
  link,
  details,
  index,
  setIsEditingToFalse,
  setIsAddImageToFalse,
  isAddImage,
  /** Globle property id from redux */
  propertyId,
  type,
  toggleButtonAddedd,
  buttonText,
  buttonValue,
  urls,
  captions,
  toggleButtonMessageAddedd,
  locale
}) {
  const [buttonTextInput, setButtonTextInput] = useState(buttonText);

  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    Code: code,
    Language: `${locale === 'en' ? 'en-US' : locale}`,
    Channel: 'WebsiteDirectLine',
    PropertyId: propertyId,
    Default: null,
    Overrides: {},
  });

  useEffect(() => {
    if (type === "link") {
      setPostData(pre => {
        return {
          ...pre,
          Default: {
            Messages: messages,
            Url: link,
            Caption: caption,
            apiButtons: [{ text: buttonTextInput, value: buttonValue }]
          },
        };
      });
      //('Image Post Data', postData);
    }
    else if (type === "messages") {
      setPostData(pre => {
        return {
          ...pre,
          Default: messages,
          apiButtons: [{ text: buttonTextInput, value: buttonValue }],
        };
      });
      //console.log('Image Post Data', postData);
    }
    else if (type === "imagecarousel") {
      let imageList = [];
      imageList = urls.map((url, index) => {
        const imgCaption = captions[index];
        return { Url: url, Caption: imgCaption };
      });
      setPostData(pre => {
        return {
          ...pre,
          Default: {
            Messages: messages,
            Images: imageList,
            apiButtons: [{ text: buttonTextInput, value: buttonValue }]
          },
        };
      });
      //console.log('Image Post Data', postData);
    }
    else if (type === "video") {
      let videoList = [];
      videoList = urls.map((url, index) => {
        const videoCaption = captions[index];
        return { Url: url, Caption: videoCaption };
      });
      setPostData(pre => {
        return {
          ...pre,
          Default: {
            Messages: messages,
            Videos: videoList,
            apiButtons: [{ text: buttonTextInput, value: buttonValue }]
          },
        };
      });
      //console.log('Image Post Data', postData);
    }
  }, [buttonTextInput]);

  const handleCaptionChange = e => {
    setButtonTextInput(e.target.value);
  };

  const handleSave = async () => {
    //console.log(postData)
    try {
      return await AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Response}`,
        data: postData,
      })
        .then(() => {
          if (setIsEditingToFalse) {
            setIsEditingToFalse();
          }
          if (setIsAddImageToFalse) {
            setIsAddImageToFalse();
          }
        })
        .finally(
          setTimeout(() => {
            toggleButtonAddedd();
            toggleButtonMessageAddedd();
            reloadBotResponse();
          }, 1000)
        );
    } catch (error) {
      console.error(error);
    }
    // toggleButtonAddedd();
    // reloadBotResponse();
  };

  const handleCancel = () => {
    if (setIsEditingToFalse) {
      setIsEditingToFalse();
    }
    if (setIsAddImageToFalse) {
      setIsAddImageToFalse();
    }
    toggleButtonAddedd();
    toggleButtonMessageAddedd();
  };
  return (
    <div>
      <Row>
        {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}
        <Colxx xxs="4">Button Title</Colxx>
        <Colxx xxs="8">
          <Input
            type="text"
            value={buttonTextInput}
            onChange={handleCaptionChange}
          ></Input>
        </Colxx>
      </Row>
      <Row>
        <Colxx xxs="4">
        </Colxx>
        <Colxx xxs="8">
          <div
            className="float-right"
            style={{ marginTop: ' 5px', marginBottom: '5px' }}
          >

            <Button
              color="secondary"
              className="add-button"
              size="xs"
              onClick={handleSave}
            >
              Save
            </Button>
            <b> </b>
            <Button
              color="light"
              className="add-button"
              size="xs"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </Colxx>
      </Row>

    </div>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};

export default injectIntl(connect(mapStateToProps)(BotResponseButton));
